import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Button,
  Icon,
  InputGroup,
  InputLeftAddon,
  Text,
  Grid,
  Flex,
} from '@chakra-ui/react'
import { useEffect, useReducer, useState } from 'react'
import { AiOutlineCloseCircle } from 'react-icons/ai'
import { BsThreeDotsVertical } from 'react-icons/bs'
import { CardImpressaoPopover } from './CardImpressaoPopover'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import { baseURL } from '../../../services/api'
import { FilterImpression } from './FilterImpression'

export const ModalRegisterImpression = ({ error, data }) => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [images, setImages] = useState([])
  const [filteredImpressions, setFilteredImpressions] = useState([])

  const { data: impressions, refetch } = useQuery(
    ['impressoes', data?.codigo_produto],
    async () => {
      const response = await baseURL.get(`/detalhes-produto/lista-impressoes-gerais/${data?.codigo_produto}`)

      const responseImp = response.data.filter((item, index, self) => index === self.findIndex((t) => t.codigo_impressao === item.codigo_impressao))

      return responseImp
    },
    {
      refetchOnMount: true,
      onSuccess: (data) => {},
    }
  )

  const [progress, setProgress] = useState({
    codigo_impressao: '',
    progress: 0,
  })

  const [quantityReducer, dispatch] = useReducer((state, action) => {
    switch (action.type) {
      case 'ADD':
        return [...state, action.payload]

      case 'REMOVE':
        return state.filter((item) => item.codigo_impressao !== action.payload.codigo_impressao)

      case 'CLEAR':
        return []

      default:
        return state
    }
  }, [])

  function removeQuantityImpSelected({ codigo_impressao, descricao_impressao, codigo_produto, id }) {
    dispatch({
      type: 'REMOVE',
      payload: {
        codigo_impressao,
        descricao_impressao,
        codigo_produto,
        id,
      },
    })
  }

  function addQuantityImpSelected({ codigo_impressao, descricao_impressao, codigo_produto, id }) {
    dispatch({
      type: 'ADD',
      payload: {
        codigo_impressao,
        descricao_impressao,
        codigo_produto,
        id,
      },
    })
  }

  async function onCloseModal() {
    onClose()
  }

  const queryClient = useQueryClient()

  const { mutateAsync, isLoading } = useMutation(
    async (data) => {
      const response = await baseURL.post('/detalhes-produto/inserir-imagens-produto-impressao', data, {
        onUploadProgress: (e) => {
          const progress = Math.round((e.loaded * 100) / e.total)

          setProgress((prev) => ({
            ...prev,
            progress,
          }))
        },
      })

      return response.data
    },

    {
      onSuccess: (data) => {
        queryClient.invalidateQueries('impressoes')
        refetch()
      },
    }
  )

  async function uploadImages() {
    const formData = new FormData()
    const paramsInserirImpressaoResponse = {
      dados: quantityReducer,
    }

    const inserirImpressaoResponse = await baseURL.post(
      'https://api.innovationbrindes.com.br/api/site/v2/detalhes-produto/inserir-impressoes-produto',
      paramsInserirImpressaoResponse
    )

    for (let i = 0; i < images.length; i++) {
      const entry = images[i]
      formData.append('imagem', entry.image)
      formData.append('codigo_impressao', entry.codigo_impressao)
      formData.append('codigo_produto', entry.codigo_produto)
      formData.append('descricao_impressao', entry.descricao_impressao)

      setProgress({
        codigo_impressao: entry.codigo_impressao,
        progress: 0,
      })

      await mutateAsync(formData)
    }

    onCloseModal()
  }

  function handleImages({ file, codImp, codProd, description }) {
    if (!file) {
      return
    }

    const newImage = {
      image: file,
      codigo_impressao: codImp,
      codigo_produto: codProd,
      descricao_impressao: description,
      codImp,
    }

    if (images.length > 0) {
      const index = images.findIndex((item) => item.codImp === codImp)

      if (index >= 0) {
        const newImages = images.filter((item) => item.codImp !== codImp)

        setImages([...newImages, newImage])

        return
      }
    }

    setImages([...images, newImage])
  }

  useEffect(() => {
    setImages([])
  }, [isOpen])

  return (
    <>
      <InputGroup>
        <InputLeftAddon children="Tipo de impressão" width="230px" borderColor={error ? 'red.500' : '#C5CED6'} />
        <Button
          borderLeftRadius={0}
          borderRightRadius="md"
          bg="transparent"
          w="100%"
          border="1px solid #378BBF"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          onClick={onOpen}
          borderColor={error ? 'red.500' : '#378BBF'}
          pr={0}
        >
          <Text fontSize="sm" mr="auto">
            {quantityReducer?.length > 0 ? quantityReducer?.length : '0'}
          </Text>
          <Icon as={BsThreeDotsVertical} fontSize="30px" color="#378BBF" />
        </Button>
      </InputGroup>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent maxW="1126px" w="full">
          <ModalHeader textAlign="center" px="125px">
            <FilterImpression setFilteredImpressions={setFilteredImpressions} impressions={impressions} />
          </ModalHeader>
          <ModalCloseButton />

          <ModalBody>
            {filteredImpressions?.length === 0 && (
              <Flex w="full" h="full" alignItems="center" justifyContent="center">
                <Text fontSize="1.2rem" fontWeight="bold">
                  Nenhuma impressão encontrada
                </Text>
              </Flex>
            )}
            <Grid
              templateColumns="repeat(2,1fr)"
              gridGap="1rem"
              placeItems="center"
              px="100px"
              maxH="520px"
              overflowY="auto"
              sx={{
                '&::-webkit-scrollbar': {
                  width: '5px',
                },
                '&::-webkit-scrollbar-track': {
                  width: '6px',
                },
                '&::-webkit-scrollbar-thumb': {
                  background: '#378BBF',
                  borderRadius: '24px',
                },
              }}
            >
              {filteredImpressions?.map((imp, index) => (
                <CardImpressaoPopover
                  {...imp}
                  key={index}
                  add={addQuantityImpSelected}
                  remove={removeQuantityImpSelected}
                  quantityReducer={quantityReducer}
                  handleImages={handleImages}
                  progress={progress}
                />
              ))}
            </Grid>
          </ModalBody>

          <ModalFooter maxW="740px" w="full" mx="auto" px="100px">
            <Button mr="auto" onClick={onClose} border={0} bg="transparent" fontSize="20px">
              <Icon as={AiOutlineCloseCircle} w="20px" h="20px" mr=".5rem" />
              Cancelar
            </Button>
            <Button
              colorScheme="blue"
              maxW="295px"
              w="full"
              rounded={'full'}
              disabled={quantityReducer.length === 0 || isLoading}
              onClick={uploadImages}
            >
              Confirmar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
